import { render, staticRenderFns } from "./MyUsersManageTagsPanel.vue?vue&type=template&id=71e615fb&scoped=true"
import script from "./MyUsersManageTagsPanel.vue?vue&type=script&lang=js"
export * from "./MyUsersManageTagsPanel.vue?vue&type=script&lang=js"
import style0 from "./MyUsersManageTagsPanel.vue?vue&type=style&index=0&id=71e615fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e615fb",
  null
  
)

export default component.exports